<template>
    <section>
        <Navbar/>
        <Spinner :color="'text-light'" v-if="isLoading" />
        <div class="calltoaction px-5">          
            <section class="row" v-if="!isLoading">
                <div class="col-md-9 text-center">
                    <div class="card my-5">
                        <div class="card-header">
                            <h2>
                                <strong>Topic : </strong>
                                {{debate.topic}}
                            </h2>
                        </div>
                        <div class="card-body">
                          <div class="row">
                              <div class="col-12">
                                    <p  class="blog-post-meta pb-4" v-if="author">
                                {{author.date}} by <a href="#">{{author.author}}</a>
                            </p>
                            <p  class="blog-post-meta pb-4" v-if="!author">
                                {{debate.created_at && debate.created_at | moment}} by
                                 <a href="#">{{debate.created_by && debate.created_by[0].first_name}}
                                      {{debate.created_by && debate.created_by[0].last_name}}</a>
                            </p>
                            <img v-if="author" class="img-fluid" :src="`${author.image}`" alt="">
                           <p class="py-4">
                                {{debate.body}}
                           </p>
                           
                              </div>
                          </div>
                        </div>
                        <div class="card-footer">
                            <div class="d-flex">
                                <a class="p-2" v-if="debate.pdf" :href="`${url()}${debate.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="debate.doc" :href="`${url()}${debate.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="debate.pic" :href="`${url()}${debate.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="debate.video" :href="`${debate.video}`" target="_blank" >Youtube</a>
                            </div>
                        </div>
                    </div>
                    <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                    LEAD OPINION (THESIS)
                                </strong>
                            </h2>
                        </div>
                        <div class="card-body">
                            <p  class="blog-post-meta pb-4">
                                {{leadOpinion.created_at && leadOpinion.created_at | moment}} by <a href="#">{{leadOpinion.created_by && leadOpinion.created_by.first_name}} {{leadOpinion.created_by && leadOpinion.created_by.last_name}}</a>
                            </p>
                            <p>
                                {{leadOpinion.text}}
                            </p>
                        </div>
                         <div class="card-footer">
                            <hr>
                             <div class="d-flex">
                                <a class="p-2" v-if="leadOpinion.pdf" :href="`${url()}${leadOpinion.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="leadOpinion.doc" :href="`${url()}${leadOpinion.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="leadOpinion.pic" :href="`${url()}${leadOpinion.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="leadOpinion.video" :href="`${leadOpinion.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div>
                    <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                    CRITIQUE (ANTI-THESIS)
                                </strong>
                            </h2>
                        </div>
                        <div class="card-body">
                             <p  class="blog-post-meta pb-4">
                                {{critique.created_at && critique.created_at | moment}} by <a href="#">{{critique.created_by && critique.created_by.first_name}} {{critique.created_by && critique.created_by.last_name}}</a>
                            </p>
                            <p>
                                {{critique.text}}
                            </p>
                        </div>
                        <div class="card-footer">
                            <hr>
                             <div class="d-flex">
                                <a class="p-2" v-if="critique.pdf" :href="`${url()}${critique.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="critique.doc" :href="`${url()}${critique.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="critique.pic" :href="`${url()}${critique.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="critique.video" :href="`${critique.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div>
                    <div class="card mb-5">
                        <div class="card-header">
                            <h2>
                                <strong>
                                    RESOLUTION ARTICLE (SYNTHESIS)
                                </strong>
                            </h2>
                        </div>
                        <div class="card-body">
                             <p  class="blog-post-meta pb-4">
                                {{resolution.created_at && resolution.created_at | moment}} by <a href="#">{{resolution.created_by && resolution.created_by.first_name}} {{resolution.created_by && resolution.created_by.last_name}}</a>
                            </p>
                            <p>
                                {{resolution.text}}
                            </p>
                        </div>
                            <div class="card-footer">
                            <hr>
                             <div class="d-flex">
                                <a class="p-2" v-if="resolution.pdf" :href="`${url()}${resolution.pdf}`" target="_blank" download>pdf</a>
                                <a  class="p-2" v-if="resolution.doc" :href="`${url()}${resolution.doc}`" target="_blank" download>document</a>
                                <a  class="p-2"  v-if="resolution.pic" :href="`${url()}${resolution.pic}`" target="_blank" download>image</a>
                                <a  class="p-2" v-if="resolution.video" :href="`${resolution.video}`" target="_blank" >Youtube</a>
                            </div>  
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <DebateSidebar/>
                </div>
            </section> 
        </div>
        <FinalFooter />
    </section>
</template>

<script>
/* allow-no-unused-vars */
import moment from 'moment'
import FinalFooter from '../FinalFooter'
import Navbar from '../appBar'
import DebateSidebar from '../debateSidebar'
import debateAuthors from '../../helpers/debates'
import Spinner from '@/components/Spinner'
import url from '../../helpers/url'

    export default {
        name:'debatecritique',
        components:{
            Navbar,
            Spinner,
            DebateSidebar,
            FinalFooter
        },
        
    filters: {
            moment: function (date) {
                return moment(date).format('MMMM Do YYYY');
            }
            },
        data() {
            return {
                debateArticleID:this.$route.params.debateID,
                leadeOpinionID:this.$route.params.leadOpinionID,
                critiqueID:this.$route.params.critiqueID,
                debate: {},
                leadOpinion:{},
                critique: {},
                resolution: {},
                isLoading:false,
                author: {},
            }
        },
        methods:{
            url() {
                return url()
            }, 
            fetchDebateDetails(){
                this.isLoading = true
                this.$store.dispatch('fetchApprovedDebateArticle')
                .then(response =>{

                    const debate = response.data.find(debate => debate.id == this.debateArticleID)
                    this.debate = debate
                    this.leadOpinion = debate.thesis[0]
                    this.critique = this.leadOpinion.antithesis[0]
                    this.resolution = this.critique.synthesis[0]

                    this.author = debateAuthors.find(author => author.id == this.$route.params.debateID)

                     if(!leadOpinion) {
                         this.$router.replace({name:'pageNotfound'})
                     }
                  
                     this.isLoading = false
                    
                })
                .catch(err => {
                    this.isLoading = false
                    //     if(err?.response?.data == undefined) {
                    //     this.toast({
                    //         message:'Network error. Check network connection and try again.',
                    //         type:'error'
                    //     })
                    // }
                    })
            }
    },
    mounted() {
        document.querySelector('body').setAttribute('style', 'background-color:#ba2428')
        this.fetchDebateDetails()
        
    },
    beforeDestroy() {
        document.querySelector('body').removeAttribute('style')
    },
    }
</script>

<style >
 button{
        background-color: #bb3826;
        color:#fff;
        border:1px solid #bb3826;
        padding:10px;
        transition: all 0.5s;
        outline: 0;
        font-size: .9em;
    }
    button:hover, button:active{
        background-color:#ffc106;
        color: #ad5457 ;
    }
    .bg-article{
        background: #bb3826;
    }
.calltoaction{
    padding-top: 150px;
    padding-left: 10px;
    padding-right: 10px;
}
.card-user {
  position: absolute;
  right: 10px;
  top: 10px;
}
.card-category {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 20px;
}
h2{
    text-transform: uppercase;
}
  .blog-post-meta {
    margin-bottom: 20px;
    color: #999;
    }
.card-header{
    background-color:#bb3826
}
.card-header h2{
    color:#fff;
}
</style>    